import { Injectable } from '@angular/core';
import { filter, map, Subject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../../../shared/services/system-message-api.service";
export class SystemMessageService {
  systemMessageApi;
  _systemMessageQue = new Subject();
  systemMessages = [];
  _newSystemMessagesArrived = new Subject();
  constructor(systemMessageApi) {
    this.systemMessageApi = systemMessageApi;
  }
  get systemMessagesQue$() {
    return this._systemMessageQue.asObservable();
  }
  get newSystemMessagesArrived$() {
    return this._newSystemMessagesArrived.asObservable();
  }
  fetchSystemMessages() {
    return this.systemMessageApi.readSystemMessages().pipe(filter(systemMessages => !!systemMessages && systemMessages.length > 0), map(systemMessages => [...systemMessages].sort((a, b) => {
      if (a.type === 'OUTAGE' && b.type !== 'OUTAGE') return -1;
      if (a.type !== 'OUTAGE' && b.type === 'OUTAGE') return 1;
      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    })), map(sortedMessages => {
      this.systemMessages = sortedMessages;
      this._newSystemMessagesArrived.next();
      return void 0;
    }));
  }
  processNextSystemMessage() {
    const firstMessage = this.systemMessages.shift();
    if (firstMessage) {
      this._systemMessageQue.next(firstMessage);
    } else {
      this._systemMessageQue.next(null);
    }
  }
  static ɵfac = function SystemMessageService_Factory(t) {
    return new (t || SystemMessageService)(i0.ɵɵinject(i1.SystemMessageApiService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SystemMessageService,
    factory: SystemMessageService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SystemMessageService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.SystemMessageApiService
  }], null);
})();
